import { render, staticRenderFns } from "./InlineBoxVersions.vue?vue&type=template&id=5efd2a3b"
import script from "./InlineBoxVersions.vue?vue&type=script&lang=js"
export * from "./InlineBoxVersions.vue?vue&type=script&lang=js"
import style0 from "./InlineBoxVersions.vue?vue&type=style&index=0&id=5efd2a3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports